import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ar from './ar'
import en from './en'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    // LANG-DEFAULT-AR-01: the tenant is Arabic-first, so a user with no stored
    // preference must land on Arabic/RTL. `fallbackLng` alone was not enough:
    // the detector's `navigator` source resolved an en-US browser to 'en' on
    // the very first login, and the fallback never applied. Detection is now
    // localStorage-only — the persisted-preference path is untouched, and with
    // nothing stored the detector yields nothing so `fallbackLng: 'ar'` wins.
    fallbackLng: 'ar',
    supportedLngs: ['ar', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  })

// تحديث direction عند تغيير اللغة
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = lng.startsWith('ar') ? 'rtl' : 'ltr'
  document.documentElement.lang = lng
})

// تطبيق direction أولي — الافتراضي عربي/RTL لو مفيش تفضيل محفوظ
const currentLang = i18n.language || 'ar'
document.documentElement.dir = currentLang.startsWith('ar') ? 'rtl' : 'ltr'
document.documentElement.lang = currentLang

export default i18n